import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, trackLinkClick, withStoredUtms } from '../lib/analytics';

export default function CalculatorPortalSignupCta({
  calculatorId,
  calculatorName,
  className = '',
}) {
  const params = new URLSearchParams({ mode: 'register' });
  if (calculatorName) params.set('source_calculator', calculatorName);
  const destination = withStoredUtms(`/portal?${params.toString()}`);
  const buttonText = 'Create My Financial Progress Portal';
  const payload = {
    button_id: `${calculatorId || 'calculator'}_portal_signup_cta`,
    button_label: buttonText,
    calculator_id: calculatorId,
    calculator_name: calculatorName,
    source_calculator: calculatorName,
    destination_type: 'portal_signup',
    cta_location: 'calculator_result',
  };

  const handleClick = () => {
    trackLinkClick(destination, buttonText, payload);
    trackEvent('portal_signup_cta_click', payload);
  };

  return (
    <div className={`pete-card pete-calculator-cta ${className}`.trim()}>
      <p className="pete-calculator-cta-eyebrow">KEEP GOING</p>
      <h2>Keep building your financial picture</h2>
      <div className="pete-calculator-cta-copy">
        <p>
          Your calculator result is one estimate. Create your Financial Progress Portal to
          connect your accounts, see your broader financial position, and monitor your progress.
        </p>
      </div>
      <div className="pete-calculator-cta-actions">
        <Link
          className="pete-btn-primary pete-calculator-cta-button"
          to={destination}
          data-button-id={payload.button_id}
          onClick={handleClick}
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
}
